module.exports = __webpack_public_path__ + "static/img/main-bottom.baa8dee3.png";